import React from "react"

import { render, cleanup, waitFor } from "@testing-library/react"
import { MockedProvider } from "@apollo/client/testing"
import { useFormContext, useForm, FormProvider } from "react-hook-form"

import RTOSelect from "../recovery-time-selection"

afterEach(cleanup)

export const RTOWithContext = (props) => {
  const methods = useForm()

  return (
    <FormProvider {...methods}>
      <form>
        <ConnectForm>{({ register }) => <RTOSelect {...props} />}</ConnectForm>
      </form>
    </FormProvider>
  )
}

export const ConnectForm = ({ children }) => {
  const methods = useFormContext()

  return children({ ...methods })
}

describe("<RTOSelect />", () => {
  it("shows RTOs as expected", async () => {
    const { getByText } = render(
      <MockedProvider addTypename={false}>
        <RTOWithContext
          onSelectChange={() => {}}
          recoveryTimes={[{ id: "1", timePeriod: "Fall", position: 1 }]}
        />
      </MockedProvider>
    )

    await waitFor(() => expect(getByText("Fall")).toBeInTheDocument())
  })
})
